import SwiperSlider from './../../legacy/_swiperSlider.class';
export default class CarouselProduct {
  constructor(mainCarousel) {
    this.mainCarousel = mainCarousel;
    this.thumbnails = mainCarousel.querySelector('.m-nav-thumbnails__container');
    this.thumbnailsItems = this.thumbnails.querySelectorAll('.m-nav-thumbnails__item');
    this.thumbnailsSwiper = mainCarousel.querySelector('.m-carousel-thumbnails');
    this.mediasSwiper = mainCarousel.querySelector('.m-carousel-main');
    this.mediasArrows = this.mediasSwiper.querySelectorAll('button');
    this.medias = this.mediasSwiper.querySelector('.m-carousel-main__layout');
    this.mediasItems = this.medias.querySelectorAll('.m-carousel-main__item');
    this.currentIndex = 0;
    this.currentThumbnail = this.thumbnailsItems[0];
    this.currentMedia = this.mediasItems[0];
    lm.DOMReady(() => this.init());
  }
  init() {
    // Launch swiper
    this.mediasSwiper && new SwiperSlider(this.mediasSwiper);
    this.thumbnailsSwiper && new SwiperSlider('.m-carousel-thumbnails');
    this.mediasArrows.forEach(arrow => arrow.addEventListener('click', e => this.onMediasArrowsClick(e, arrow)));
    this.medias.addEventListener('scroll', () => this.toggleMediasArrowButtons());
    this.thumbnailsItems.forEach(item => item.addEventListener('click', e => this.onThumbnailsItemsClick(e)));
  }

  /**
   * User click on a thumbnail item
   * @param {event} e
   */
  onThumbnailsItemsClick(e) {
    const container = e.target.closest('.m-nav-thumbnails__item');
    this.enableArrows(false);
    this.goTo(container.dataset.index || 0, 'smooth');
  }
  /**
   * Display medias arrows on thumbnails if necessary
   */
  toggleMediasArrowButtons() {
    const mediasScrollOffset = this.medias.scrollLeft;
    const mediasWidth = (this.mediasItems.length - 1) * this.medias.clientWidth;
    const [arrowPrev, arrowNext] = this.mediasArrows;
    arrowPrev.classList.toggle('ka-nav-button--hidden', mediasScrollOffset <= 0);
    arrowNext.classList.toggle('ka-nav-button--hidden', mediasScrollOffset >= mediasWidth);
  }

  /**
   * When user use media arrow to scroll items
   * @param {event} event
   * @param {node} arrow
   */
  onMediasArrowsClick(event, arrow) {
    this.enableArrows(false);
    if (arrow.dataset.controls === 'prev') this.goTo(this.currentIndex - 1, "smooth");
    if (arrow.dataset.controls === 'next') this.goTo(this.currentIndex + 1, "smooth");
  }

  /**
   * Go to a specific index
   * (synchronize thumbnails and medias)
   * @param {number} index
   * @param {string} behavior
   */
  goTo(index = 0, behavior = null) {
    index = getMinMax(+index, 0, this.thumbnailsItems.length);
    if (index === this.currentIndex) behavior = 'instant';
    this.currentIndex = index;
    this.currentThumbnail = this.thumbnailsItems[index];
    this.currentMedia = this.mediasItems[index];
    if (this.currentThumbnail && this.currentMedia) {
      this.thumbnailsItems.forEach(item => item.classList.toggle('is-active', +item.dataset.index === this.currentIndex));
      this.medias.scrollTo({
        left: this.currentMedia.offsetLeft - getComputedStyle(this.medias).borderWidth.split('px')[0] * 1,
        behavior
      });
      this.thumbnails.scrollTo({
        top: this.currentThumbnail.offsetTop,
        behavior
      });
    }

    // Reset All medias after transition
    clearTimeout(this.resetTimeout);
    this.resetTimeout = setTimeout(() => {
      this.pauseAllVideos();
      this.toggleMediasArrowButtons();
      this.enableArrows(true);
    }, 750);
  }

  /**
   * Enable or disable arrows buttons
   * @param {boolean} state
   */
  enableArrows(state = true) {
    this.mediasArrows.forEach(button => button.disabled = !state);
  }

  /**
   * Rewind and pause all videos
   */
  pauseAllVideos() {
    this.mainCarousel.querySelectorAll('video').forEach(video => {
      video.pause();
      video.currentTime = 0;
    });
  }
}

/**
 * Return a value bettween min an max
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
function getMinMax(value = 0, min = 0, max = Infinity) {
  let newValue = value;
  newValue = Math.max(newValue, min);
  newValue = Math.min(newValue, max);
  return newValue;
}